// import ModalForm from "./Form";
import DirectPlacementTableForm from "./DirectPlacementTableForm";
import {
	PLACEMENT_REASON,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const DirectPlacementTableSchema = {
	components: { DirectPlacementTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: "",
			Endpoint: PLACEMENT_REASON + "?placement_id=" + this.placementId,
			tableId: "direct-placement-table",
			formId: "direct-placement-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Reason",
					type: "custom-html",
					key: "reason_name",
					modifier: (value) => {
						return value.name;
					},
				},
				{
					title: "Comment (by Academic)",
					type: "text",
					key: "comment",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "DirectPlacementTable",
				url: PLACEMENT_REASON + "?placement_id=" + this.placementId,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "direct-placement-table-form",
						modalId: "direct-placement-table-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
